import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStores } from 'hooks';
import {
  FloorBidderBadgeValidation,
  DecisionButtonText,
} from 'components/project/ClerkScreen';
import { DecisionButton, HotKeyLabel } from '../Styles';

const IfSaleButton = () => {
  const {
    BidStore: {
      auction,
      showIfSaleButton,
      shouldDisableDecisionButtons,
      laneSuspended,
    },
    UIStore: {
      handleDecisionClick,
      handleRejectFBBValidation,
      handleProceedFBBValidation,
      getHotKey,
    },
  } = useStores();

  const key = auction.firstDecisionClick;
  const buttonText = 'If Sale';
  const saleType = 'SubjectTo';
  const buttonWasFirstClicked = key === saleType && laneSuspended;

  return (
    <>
      {showIfSaleButton ? (
        <DecisionButton
          isFirstClick={buttonWasFirstClicked}
          invalid={false}
          disabled={shouldDisableDecisionButtons}
          onClick={() => handleDecisionClick(saleType)}
          tabIndex={7}
          color="#000000"
          bgColor="#FBCC08"
          firstClick={buttonWasFirstClicked}
          bgVariance={20}
          data-testid="ifsale-btn"
        >
          <DecisionButtonText confirming={laneSuspended} text={buttonText} />
          <HotKeyLabel color="black">
            {getHotKey('target', 'IF SALE').label}
          </HotKeyLabel>
        </DecisionButton>
      ) : (
        <FloorBidderBadgeValidation
          decisionText={buttonText}
          handleReject={handleRejectFBBValidation}
          handleProceed={handleProceedFBBValidation(saleType)}
        />
      )}
    </>
  );
};

export default observer(IfSaleButton);
